import { Link } from "react-router-dom";
import logo from "../assets/img/logotipo.png";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/*-------------------- Inicio Footer simple --------------------*/}
      <footer
        className="bg-[#2a3180] mt-16 sm:mt-20 md:mt-24 py-6 sm:py-8 md:py-10"
        translate="no"
      >
        <div className="container mx-auto px-4 sm:px-6">
          {/* Logo arriba a la izquierda */}
          <div className="flex items-center justify-start mb-6 sm:mb-8 md:mb-10">
            <img
              src={logo}
              alt="Industrial Business Clusters"
              className="h-16 sm:h-20 md:h-24 lg:h-28 w-auto object-contain"
            />
            <div className="ml-3 sm:ml-4 md:ml-5 text-white">
              <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold leading-tight tracking-wide">
                INDUSTRIAL
                <br />
                BUSINESS
                <br />
                CLUSTERS
              </h2>
            </div>
          </div>

          {/* Aviso de privacidad y Copyright abajo a la derecha */}
          <div className="flex justify-end">
            <div className="text-right text-white space-y-1">
              <Link
                to="/aviso-de-privacidad"
                className="block text-xs sm:text-sm hover:underline uppercase tracking-wider"
              >
                Aviso de Privacidad
              </Link>
              <p className="text-xs sm:text-sm opacity-80">
                Copyright © {currentYear} Todos los derechos reservados
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/*-------------------- Fin Footer simple --------------------*/}
    </>
  );
}
export default Footer;
